<template>
  <div class="live-checklist-wrapper">
    <modal ref='filterModal' class="checklist-filter">
      <template #header>
        <h5 class="modal-title mt-0">{{ $t('folders_list.filter_items') }}</h5>
      </template>
      <template #body>
        <form>
          <div class='modal-body'>
            <div class="form-group">
              <label>
                {{ userProductTitle }}
              </label>
              <PinkCatSelect
                  :selected-filters="selectedProducts"
                  :single-select="false"
                  :options-for-select="products"
                  :template="productTemplate"
                  @add="addProduct"
                  @remove="removeProduct"
                  @clearSelectedOption="clearSelectedForProduct"/>
            </div>
            <div class="form-group">
              <label>
                {{ userDocumentTypeTitle }}
              </label>
              <PinkCatSelect
                  :selected-filters="selectedDocumentTypes"
                  :single-select="false"
                  :options-for-select="documentTypes"
                  :template="documentTypeTemplate"
                  @add="addDocumentType"
                  @remove="removeDocumentType"
                  @clearSelectedOption="clearSelectedForDocumentTypes"/>
            </div>
          </div>
          <div class='modal-footer'>
            <input @click.prevent='clearFilter' type='reset' class="btn btn-neutral float-right"
                   :value="$t('folders_list.clear_filters')"/>
            <button type='submit' class="btn btn-outline-primary float-right" @click.prevent="filterChecklist">{{ $t('folders_list.filter') }}
            </button>
          </div>
        </form>
      </template>
    </modal>

    <section class="ui-line-wrapper">
      <div class="checklist-status-wrapper">
        <Status :items-count="checklistItems.length" :completed-items-count="completedItems.length"></Status>
      </div>
    </section>

    <section class="ui-line-wrapper page-filters">
      <div class="btn-group float-left show-hide-columns" role="group" v-click-outside="closeShowColumnsDropdown" >
        <button class="btn btn-neutral dropdown-toggle" @click.prevent="showColumnsDropdown = !showColumnsDropdown">
          {{$t('records_list.show_hide') }}
        </button>

        <ul class="dropdown-menu" v-show="showColumnsDropdown">
          <li class="dropdown-item" @click="toggleColumns('document_types')">
            <input type="checkbox" :checked="enabledColumns['document_types']" />
            {{$t('checklist.headers.document_type')}}
          </li>
          <li class="dropdown-item" @click="toggleColumns('products')">
            <input type="checkbox" :checked="enabledColumns['products']" />
            {{$t('checklist.headers.products')}}
          </li>
          <li class="dropdown-item" @click="toggleColumns('files')">
            <input type="checkbox" :checked="enabledColumns['files']" />
            {{$t('checklist.headers.files')}}
          </li>
        </ul>
      </div>

      <a class="btn btn-neutral filter-checklist" href="#" v-if="checklistItems.length !== 0"
         @click.prevent="$refs.filterModal.open">
        {{ $t('checklist.filters') }}
      </a>
      <div class="search-container-wrapper"
           v-if="checklistItems.length !== 0">
        <i class="fas fa-search"></i>
        <i class="fas fa-times" v-if="searchTerm.length > 0" @click.prevent="searchTerm = ''"></i>
        <input
          type="text"
          name="search"
          v-model="searchTerm"
          class="form-control search-field"
          autocomplete="off"
          :placeholder="$t('checklist.search')"/>
        <div class="clearfix"></div>
      </div>
    </section>
    <div class="filter-results" v-if="hasFilters">
      <strong>{{ $t('checklist.filter_results_for') }}</strong>
      <p v-if="selectedProducts.length > 0"> {{ userProductTitle }} <strong v-for="product in selectedProducts"> {{ product.code? [product.name, product.code].filter(v => v).join(" - "): product.name}},</strong></p>
      <p v-if="selectedDocumentTypes.length > 0"> {{ userDocumentTypeTitle }} <strong v-for="document in selectedDocumentTypes">{{document.name}}, </strong></p>
      <p v-if="visibleToPartner != null"> {{ $t('checklist.items_filter') }}
        <strong v-if="visibleToPartner === true">{{ $t('checklist.items_shared') }}</strong>
        <strong v-if="visibleToPartner === false">{{ $t('checklist.items_not_shared') }}</strong>
      </p>
      <p v-if="containsFiles != null"> {{ $t('checklist.items_files') }}
        <strong v-if="containsFiles === true">{{ $t('checklist.yes_way') }}</strong>
        <strong v-if="containsFiles === false">{{ $t('checklist.no_way') }}</strong>
      </p>
      <a href="#" @click.prevent="clearFilter">{{ $t('checklist.clear') }}</a>
    </div>
    <div v-if="hasFilters && filteredItems.length === 0"
         class="empty-list-wrapper">
      <img src="../../assets/empty_states/checklist.png"/>
      <p>
        {{ $t('checklist.no_results_filter') }}
      </p>
    </div>
    <div v-else-if="checklistItems.length === 0"
         class="empty-list-wrapper">
      <img src="../../assets/empty_states/checklist.png"/>
      <p>
        {{ $t('checklist.empty') }}
        <br/>
        {{ $t('checklist.adding_items') }}
      </p>
    </div>

    <div class="clearfix table_wrapper" v-else>
      <table class="table checklist-table">
        <thead>
          <tr>
            <th v-show="enabledColumns['document_types']">{{$t('checklist.headers.document_type')}}</th>
            <th v-show="enabledColumns['products']">{{$t('checklist.headers.products')}}</th>
            <th v-show="enabledColumns['files']"> {{$t('checklist.headers.files')}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in filteredItems" :key="item.id" class="list-item">
            <td class="checklist-content-column" v-show="enabledColumns['document_types']">
              <div class="document-type-bubble">
                <p>{{ item.document_type.name }}</p>
              </div>
            </td>
            <td class="checklist-content-column" v-show="enabledColumns['products']">
              <div class="product-bubble">
                <p>{{ [item.product.code, item.product.name].filter(v => v).join(" - ") }}</p>
              </div>
            </td>
            <td class="checklist-check-column" v-show="enabledColumns['files']">
              <div v-if="item.record_id && item.checked" class="file-bubble">
                <b>{{ $t('checklist.uploaded_file') }}</b>
                <router-link :to="{name: 'shared_record_show', params: { id: item.record_id }}">
                  {{ item.record.filename }}
                </router-link>
                <br/>
                <div class="exp-status">
                  <span v-if="item.record.status === 'current'">
                    {{ $t('records_list.table.up_to_date') }}
                  </span>
                  <span v-else-if="item.record.status === 'soon'" class="soon">
                      {{ $t('records_list.table.expires_soon') }}
                    </span>
                  <span v-else-if="item.record.status === 'expired'" class="expired">
                      {{ $t('records_list.table.expired') }}
                  </span>
                  <span v-else class="no-expiration">
                      {{ $t('records_list.table.no_expiration') }}
                  </span>
                </div>
              </div>
              <div class="file-bubble" v-else>
                <p>{{$t('checklist.no_way')}}</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
  import Status from './_status'
  import PinkCatSelect from "../shared/PinkCatSelect"
  import Modal from "../_modal"

  export default {
    components: {
      Status,
      PinkCatSelect,
      Modal,
    },
    props: ['folderId', 'permission'],
    name: 'SharedChecklist',
    data() {
      return {
        searchTerm: '',
        selectedFolders: [],
        selectedProducts: [],
        selectedDocumentTypes: [],
        productIds: [],
        documentTypeIds: [],
        visibleToPartner: null,
        containsFiles: null,
        bulkCheckList: [],
        addAllChecklist: null,
        addChecklistToBulk: null,
        copyRecords: false,
        execute: null,
        checklist: null,
        disableCopyItems: true,
        showColumnsDropdown: false,
      }
    },
    created() {
      this.loadChecklist()
    },
    computed: {
      checklistItems() {
        return this.state.sharedFolderChecklist || []
      },
      completedItems() {
        return this.checklistItems.filter(ci => ci.checked)
      },
      hasFilters() {
        return !!(this.selectedProducts.length > 0 ||
          this.selectedDocumentTypes.length > 0 ||
          this.visibleToPartner != null||
          this.containsFiles != null)
      },
      products() {
        const list = this.checklistItems.map(ci => ci.product)

        return [...new Map(list.map(item => [item.id, item])).values()]
      },
      folders() {
        const folders = this.lists.folders || []

        return folders.filter(f => !f.primary)
      },
      documentTypes() {
        const list = this.checklistItems.map(ci => ci.document_type)

        return [...new Map(list.map(item => [item.id, item])).values()]
      },
      filteredItems() {
        let checklist = this.checklistItems
        if (this.containsFiles !== null) {
          checklist = checklist.filter(v => v.checked === this.containsFiles)
        }
        if (this.visibleToPartner !== null) {
          if(this.visibleToPartner) {
            checklist = checklist.filter(v => v.shared === this.visibleToPartner && v.checked === false)
          } else {
            checklist = checklist.filter(v => v.shared === this.visibleToPartner && v.checked === false)
          }
        }
        if (this.productIds.length > 0) {
          checklist = checklist.filter(v => this.productIds.includes(v.product_id))
        }
        if (this.documentTypeIds.length > 0) {
          checklist = checklist.filter(v => this.documentTypeIds.includes(v.document_type_id))
        }
        if (this.searchTerm !== null && this.searchTerm.length > 0) {
          return checklist.filter(v => {
            let s = v.document_type.name.indexOf(this.searchTerm) !== -1
            s = s || v.product.name.indexOf(this.searchTerm) !== -1
            return s || v.product.code && v.product.code.indexOf(this.searchTerm) !== -1
          })
        } else {
          return checklist
        }
      },

      checklistColumns() {
        return this.userDefaults['folder_checklist'] || []
      },
      enabledColumns() {
        const cols = {}
        this.checklistColumns.forEach(c => cols[c] = true)
        return cols
      },
    },
    methods: {
      openHideModal(){
        this.checklist = null
        this.$refs.hideUnhide.open()
        this.execute = this.openHideOperation
      },

      loadChecklist() {
        this.store.getSharedFolderChecklist(this.$props.folderId)
      },

      filterChecklist() {
        this.$refs.filterModal.close()
        if (this.selectedProducts.length > 0) {
          this.productIds = this.selectedProducts.map(ci => ci.id)
        }
        if (this.selectedDocumentTypes.length > 0) {
          this.documentTypeIds = this.selectedDocumentTypes.map(ci => ci.id)
        }
      },
      clearFilter() {
        this.$refs.filterModal.close()
        this.productIds = []
        this.selectedDocumentTypes = []
        this.selectedProducts = []
        this.documentTypeIds = []
        this.visibleToPartner = null
        this.containsFiles = null
      },
      productTemplate(item) {
        return item.code ? `${item.name} - ${item.code}` : item.name;
      },
      documentTypeTemplate(item) {
        return item.name
      },

      clearSelectedForProduct() {
        this.selectedProducts = []
      },
      clearSelectedForDocumentTypes() {
        this.selectedDocumentTypes = []
      },
      clearSelectedForFolder() {
        this.selectedFolders = []
        this.disableCopyItems = true
      },
      addFolder(item) {
        if (!this.selectedFolders.includes(item)) {
          this.selectedFolders.push(item)
          this.disableCopyItems = false
        }
      },
      removeFolder(item) {
        let index = this.selectedFolders.indexOf(item)
        if (index > -1) {
          this.selectedFolders.splice(index, 1)
          if (this.selectedFolders.length === 0) {
            this.disableCopyItems = true
          }
        }
      },
      addProduct(item) {
        if (!this.selectedProducts.includes(item)) {
          this.selectedProducts.push(item)
        }
      },
      addDocumentType(item) {
        if (!this.selectedDocumentTypes.includes(item)) {
          this.selectedDocumentTypes.push(item)
        }
      },
      removeProduct(item) {
        let index = this.selectedProducts.indexOf(item)
        if (index > -1) {
          this.selectedProducts.splice(index, 1)
        }
      },
      removeDocumentType(item) {
        let index = this.selectedDocumentTypes.indexOf(item)
        if (index > -1) {
          this.selectedDocumentTypes.splice(index, 1)
        }
      },
      clearOption() {
        this.visibleToPartner = null
      },
      clearFileOption() {
        this.containsFiles = null
      },
      addAllToBulkChecklist() {
        if (this.addAllChecklist) {
          this.checklist = null
          this.bulkCheckList = this.filteredItems
        } else {
          this.bulkCheckList = []
        }
      },

      toggleColumns(column) {
        const newColumns = new Set(this.checklistColumns)
        this.enabledColumns[column] ? newColumns.delete(column) : newColumns.add(column)

        const params = {
          user: {
            defaults: Object.assign({}, this.userDefaults, { folder_checklist: Array.from(newColumns) })
          }
        }

        this.store.updateUserProfile(params).then(() => {
          this.store.sendMetrics({name: 'toggle_columns_checklist', params: this.$route.params, path: this.$route.fullPath})
          this.store.getCurrentUser()
        })
      },
      closeShowColumnsDropdown() {
        this.showColumnsDropdown = false
      },
    },
  }
</script>
<style lang="sass">
  @import "../../styles/checklists.sass"
  @import "../../styles/tags_manager.sass"
  .note
    background-color: #EAF0FF
    padding: 5px
    border-radius: 5px
    font-size: 14px
    color: #000
    margin-bottom: 20px
  .btn-outline-danger
    margin-right: 10px
  .checklist-filter
    .form-group
      margin-bottom: 20px
      label
        display: block
        text-align: left
    .form-inline
      label
        width: 20%
        text-align: left
        &:first-child
          width: 50%
        &:last-child
          width: 5%
          color: #686868
          cursor: pointer
  .shared-folder-show
    .checklist-status-wrapper
      width: 100%
</style>

